(function () {
  var d = document, w = window;
  /* Cart extras */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mb-addon]');
    if (!b) return;
    b.disabled = true; b.classList.add('is-busy');
    fetch((w.Shopify && w.Shopify.routes ? w.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-mb-addon'), 10), quantity: 1 }] }) })
      .then(function () { location.reload(); })
      .catch(function () { b.disabled = false; b.classList.remove('is-busy'); });
  });

})();
